import { render } from "./ModalTemplateOrcamento.vue?vue&type=template&id=0b11cc34&scoped=true"
import script from "./ModalTemplateOrcamento.vue?vue&type=script&lang=js"
export * from "./ModalTemplateOrcamento.vue?vue&type=script&lang=js"

import "./ModalTemplateOrcamento.vue?vue&type=style&index=0&id=0b11cc34&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b11cc34"]])

export default __exports__